import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Alert, Button } from 'react-bootstrap';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PayUSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  
  const paymentStatus = params.get('status');
  const txnid = params.get('txnid');
  const amount = params.get('amount');

  useEffect(() => {
    // Log the successful payment to your backend
    console.log('Payment successful:', { txnid, amount });

    // Notify parent window with payment details
    if (window.opener) {
      window.opener.postMessage(
        { type: "payment_success", txnid, status: paymentStatus },
        "*"
      );
    }

    // Redirect to PayUPayment with query parameters
    const queryParams = new URLSearchParams();
    if (txnid) queryParams.set("txnid", txnid);
    if (paymentStatus) queryParams.set("status", paymentStatus);
    if (amount) queryParams.set("amount", amount);

  //   setTimeout(() => {
  //     navigate(`/pay-u-payment?${queryParams.toString()}`);
  //   }, 1000);
  // }, [navigate, txnid, paymentStatus, amount]);
setTimeout(() => {
  window.location.href = `myapp://payment-success?txnid=${txnid}&status=${paymentStatus}&amount=${amount}`;
}, 1000);
}, []);
  return (
    <Container className="py-5 text-center">
      <div className="d-flex justify-content-center mb-4">
        <FontAwesomeIcon 
          icon={faCheckCircle} 
          size="4x" 
          className="text-success"
        />
      </div>
      <h2 className="mb-3">Thank you!</h2>
      <Alert variant="success" className="mb-4">
        <p className="mb-1">Transaction ID: {txnid}</p>
        <p className="mb-1">Amount: ₹{amount}</p>
        <p>Status: {paymentStatus}</p>
      </Alert>
      <p className="mb-4">
        Your transaction has been completed successfully. Redirecting back to payment page...
      </p>
      
      <Button 
        variant="primary" 
        onClick={() => navigate(`/index`)}
      >
        Return to Payment
      </Button>
    </Container>
  );
};

export default PayUSuccess;